import { render, staticRenderFns } from "./ZoomInfoCard.vue?vue&type=template&id=b6d1fa86"
import script from "./ZoomInfoCard.vue?vue&type=script&lang=js"
export * from "./ZoomInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports